import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FinancialsService } from '../service/financials.service';
import { ImageUploaderService } from '../services/image-uploader.service';
import { ApplicantService } from '../services/applicant.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-document-master',
  templateUrl: './document-master.component.html',
  styleUrls: ['./document-master.component.css']
})
export class DocumentMasterComponent implements OnInit {
  documentForm!: FormGroup;
  finYears: any[] = [];

  constructor(
    private fb: FormBuilder,
    private financialService: FinancialsService,
    private uploadService:ImageUploaderService,
    private applicantS:ApplicantService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.loadFinancialYears();
    this.getAllDocument();
  }

  initForm() {
    this.documentForm = this.fb.group({
      financialYear: ['', Validators.required],
      userType: ['', Validators.required],
      document: ['', Validators.required]
    });
  }

  loadFinancialYears() {
    this.financialService.getFinYears().subscribe({
      next: (resp: any) => {
        this.finYears = resp.data;
      },
      error: (err: any) => {
        console.error(err);
      }
    });
  }

  onFileSelected(event: Event) {
    const file = (event.target as HTMLInputElement)?.files?.[0];
    if (file) {
      this.documentForm.patchValue({ document: file });
      this.documentForm.get('document')?.updateValueAndValidity();
    }
  }

  addDocument() {
    if (this.documentForm.invalid) {
      this.documentForm.markAllAsTouched();
      return;
    }

    this.spinner.show();
    this.applicantS.submitDocument(this.documentForm.value,'add-document').subscribe({
      next:(resp:any)=>{
        this.spinner.hide();
        window.location.reload();
      },
      error:(error:any)=>{
        this.spinner.hide();
      }
    });
  }

    uploadDocument(e:any){
    this.uploadService.uploadFiles(e).subscribe({
      next:(files:any)=>{
        if(files?.file!==undefined){
          this.fileUploader(files?.file);
        }
      }
    });
  }

    fileUploader(file: any): void {
     this.applicantS.upload(file).subscribe({
      next:(resp:any)=>{
        this.documentForm.get('document')?.patchValue(resp.body);
      }
    });
  }

documentList:any[]=[];
  getAllDocument(): void{
    this.financialService.post('get-all-document',{}).subscribe({
      next:(resp:any)=>{
        
        if(resp['status']=='success'){
          resp['result']?.filter((item:any)=>{
          let str = item.document.split('/')[3].split('.')[0];
          item['fileName']= str;
          item['financialYear'] = item.financialYear?.financialYear
          });
          console.log(resp);
          this.documentList = resp['result'];
        }
      }
    });
  }

  deleteDocument(id:string): void{
       Swal.fire({
          text: 'Are you sure you want to delete?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.isConfirmed) {
            this.financialService.post('delete-document',{id:id}).subscribe({
              next: (resp: any) => {
                if (resp['status']=='success') {
                  Swal.fire('Document deleted successfully.', '', 'success');
                  window.location.reload();
                } else {
                  Swal.fire(resp.message, '', 'error');
                }
              },
              error: (err: any) => {
                Swal.fire('Something went wrong!', '', 'error');
              }
            });
          } else if (result.isDismissed) {
          }
        });
  }

  openFile(reportFile:string): void {
  const newUrl = reportFile.replace('http://13.235.172.47:3000', 'https://award.face-cii.in');
const encodedUrl = encodeURI(newUrl);
  if (reportFile) {
          const a = document.createElement('a');
          a.href = encodedUrl;
          a.target = '_blank'; // Open in new tab
          a.rel = 'noopener';  // Recommended for security
          a.click();
        }
  
}
  


}
